import type React from 'react';

import { useGetFaceAttributes } from '@vlabs/api/luna-api/client';
import type { FaceId } from '@vlabs/api/luna-api/model';
import { AgeAttributeCard, GenderAttributeCard } from '@vlabs/monokit/shared/ui/atribute-cards';

import st from './FaceAttributes.module.sass';

interface FaceBasicAttributesProps {
  faceId: FaceId;
}

function FaceBasicAttributes({
  faceId,
}: FaceBasicAttributesProps): React.JSX.Element {
  const getFaceAttributes = useGetFaceAttributes(faceId);
  const basicAttributes = getFaceAttributes.data?.attributes.basic_attributes;

  return (
    <div className={st.Root}>
      {!!basicAttributes?.gender && <GenderAttributeCard gender={basicAttributes.gender} />}
      {!!basicAttributes?.age && <AgeAttributeCard age={basicAttributes.age} />}
    </div>
  );
}

export { FaceBasicAttributes };
